// AUTO-GENERATED — do not edit.
// Source: business/ishvaram/data/governance/value_surface_placements.yaml
// Regenerate: uv run python execution/generate_offer_placement_ts.py

// Packed browser projection. The exact catalog remains available to TypeScript.

export type RuntimeOfferPlacementPolicyCatalog = {
  "/choghadiya_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["timing_muhurat"];
    offerPlans: ["muhurat_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/choghadiya", "/choghadiya/{city}"];
  };
  "/dasamsa_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["career"];
    offerPlans: ["career_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/dasamsa"];
  };
  "/dasha-calculator_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["mahadasha_forecast"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/dasha-calculator"];
  };
  "/hi/choghadiya_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["timing_muhurat"];
    offerPlans: ["muhurat_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/hi/choghadiya", "/hi/choghadiya/{city}"];
  };
  "/hi/dasamsa_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["career"];
    offerPlans: ["career_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/hi/dasamsa"];
  };
  "/hi/dasha-calculator_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["mahadasha_forecast"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/hi/dasha-calculator"];
  };
  "/hi/kaal-sarp-dosha_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["remedy_dosha"];
    offerPlans: ["dosha_remedy_plan"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/hi/kaal-sarp-dosha"];
  };
  "/hi/lal_kitab_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["lal_kitab_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/hi/lal-kitab-kundli"];
  };
  "/hi/muhurat_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["timing_muhurat"];
    offerPlans: ["muhurat_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/hi/muhurat"];
  };
  "/hi/navamsa_chart_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["marriage_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/hi/navamsa-chart"];
  };
  "/hi/pitra-dosha_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["remedy_dosha"];
    offerPlans: ["pitra_dosh"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/hi/pitra-dosha"];
  };
  "/hi/rashi_calculator_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["brihat_kundali"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/hi/rashi-calculator"];
  };
  "/hi/sade-sati_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["remedy_dosha"];
    offerPlans: ["sade_sati"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/hi/sade-sati"];
  };
  "/hi/shadbala_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["brihat_kundali"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/hi/shadbala"];
  };
  "/kaal-sarp-dosha_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["remedy_dosha"];
    offerPlans: ["dosha_remedy_plan"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/kaal-sarp-dosha"];
  };
  "/lal_kitab_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["lal_kitab_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/lal-kitab-kundli"];
  };
  "/muhurat_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["timing_muhurat"];
    offerPlans: ["muhurat_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/muhurat"];
  };
  "/navamsa_chart_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["marriage_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/navamsa-chart"];
  };
  "/pitra-dosha_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["remedy_dosha"];
    offerPlans: ["pitra_dosh"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/pitra-dosha"];
  };
  "/rashi_calculator_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["brihat_kundali"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/rashi-calculator"];
  };
  "/sade-sati_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["remedy_dosha"];
    offerPlans: ["sade_sati"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/sade-sati"];
  };
  "/shadbala_report_bridge": {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["brihat_kundali"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/shadbala"];
  };
  baby_name_lookup_below_result: {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["baby_name_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/baby-names", "/hi/baby-names"];
  };
  birth_identity_lookup_below_result: {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["brihat_kundali"];
    actionModes: ["input_collection"];
    sourcePathTemplates: [
      "/ascendant-calculator",
      "/hi/ascendant-calculator",
      "/hi/nakshatra-calculator",
      "/nakshatra-calculator",
    ];
  };
  "chat-reading-primary": {
    runtimeOwners: ["OfferPlacement"];
    intents: ["chat"];
    offerPlans: [];
    actionModes: ["direct_checkout"];
    sourcePathTemplates: ["/chat/{readingId}/"];
  };
  chat_paywall: {
    runtimeOwners: ["ChatPaywallTelemetry"];
    intents: ["chat"];
    offerPlans: [];
    actionModes: ["direct_checkout"];
    sourcePathTemplates: [
      "/",
      "/ai-astrologer",
      "/ai-kundli",
      "/astrologer-for-marriage-problem",
      "/birth-chart",
      "/career-astrology",
      "/career-astrology-consultation",
      "/chat-with-astrologer",
      "/chat/{readingId}/",
      "/free-kundali",
      "/hi/career-ke-liye-jyotish",
      "/hi/free-kundali",
      "/hi/jyotishi-se-baat-karen",
      "/hi/jyotishi-se-chat",
      "/hi/muft-jyotish-chat",
      "/hi/nadi-astrology",
      "/hi/shaadi-ke-liye-jyotish",
      "/nadi-astrology",
      "/talk-to-astrologer",
    ];
  };
  gun_milan_results_primary: {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["marriage_report"];
    actionModes: ["direct_checkout"];
    sourcePathTemplates: ["/gun-milan"];
  };
  hi_gun_milan_results_primary: {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["marriage_report"];
    actionModes: ["direct_checkout"];
    sourcePathTemplates: ["/hi/gun-milan"];
  };
  kaal_sarp_result_primary: {
    runtimeOwners: ["GovernedOfferPlacement"];
    intents: ["dosha_remedy"];
    offerPlans: ["dosha_remedy_plan"];
    actionModes: ["direct_checkout"];
    sourcePathTemplates: ["/kaal-sarp-dosh"];
  };
  karungali_guide_product_offer: {
    runtimeOwners: ["GovernedOfferPlacement"];
    intents: ["dosha_remedy"];
    offerPlans: [];
    actionModes: ["direct_checkout"];
    sourcePathTemplates: ["/blog/karungali-mala-guide"];
  };
  "kundali-result-primary": {
    runtimeOwners: ["OfferPlacement"];
    intents: ["birth_chart"];
    offerPlans: [];
    actionModes: ["direct_checkout"];
    sourcePathTemplates: [
      "/",
      "/ai-astrologer",
      "/ai-kundli",
      "/astrologer-for-marriage-problem",
      "/birth-chart",
      "/career-astrology",
      "/career-astrology-consultation",
      "/chat-with-astrologer",
      "/free-kundali",
      "/hi/career-ke-liye-jyotish",
      "/hi/free-kundali",
      "/hi/jyotishi-se-baat-karen",
      "/hi/jyotishi-se-chat",
      "/hi/muft-jyotish-chat",
      "/hi/nadi-astrology",
      "/hi/shaadi-ke-liye-jyotish",
      "/kundali/{readingId}",
      "/nadi-astrology",
      "/talk-to-astrologer",
    ];
  };
  kundli_matching_results_primary: {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["marriage_report"];
    actionModes: ["direct_checkout"];
    sourcePathTemplates: ["/hi/kundli-matching", "/kundli-matching", "/match/{token}"];
  };
  mangal_dosha_result_primary: {
    runtimeOwners: ["GovernedOfferPlacement"];
    intents: ["chart_report", "dosha_remedy", "matching"];
    offerPlans: [];
    actionModes: ["direct_checkout", "input_collection"];
    sourcePathTemplates: ["/hi/mangal-dosha-calculator", "/mangal-dosha-calculator"];
  };
  match_share_results_primary: {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["marriage_report"];
    actionModes: ["direct_checkout"];
    sourcePathTemplates: ["/match/{token}"];
  };
  muhurat_event_value_moment: {
    runtimeOwners: ["OfferImpression"];
    intents: ["timing_muhurat"];
    offerPlans: ["muhurat_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/muhurat/{event}", "/muhurat/{event}/{month}"];
  };
  numerology_lookup_below_result: {
    runtimeOwners: ["OfferImpression"];
    intents: ["chart_report"];
    offerPlans: ["numerology_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: [
      "/bhagyank-calculator",
      "/hi/bhagyank-calculator",
      "/hi/mulank-calculator",
      "/hi/name-numerology",
      "/hi/numerology",
      "/mulank-calculator",
      "/name-numerology",
      "/numerology",
      "/numerology/{mulank}",
    ];
  };
  pitra_dosh_result_primary: {
    runtimeOwners: ["GovernedOfferPlacement"];
    intents: ["pitra_dosh_report"];
    offerPlans: ["pitra_dosh"];
    actionModes: ["direct_checkout"];
    sourcePathTemplates: ["/pitra-dosh-calculator"];
  };
  report_reading_upsell: {
    runtimeOwners: ["ReportReadingUpsellClient"];
    intents: ["forecast"];
    offerPlans: [];
    actionModes: ["direct_checkout"];
    sourcePathTemplates: ["/r/{token}"];
  };
  shani_transit_below_result: {
    runtimeOwners: ["OfferImpression"];
    intents: ["remedy_dosha"];
    offerPlans: ["sade_sati"];
    actionModes: ["input_collection"];
    sourcePathTemplates: ["/shani-transit"];
  };
  timing_lookup_below_result: {
    runtimeOwners: ["OfferImpression"];
    intents: ["festival_ritual", "timing_muhurat"];
    offerPlans: ["muhurat_report"];
    actionModes: ["input_collection"];
    sourcePathTemplates: [
      "/calendar",
      "/calendar/festival/{id}",
      "/hi/calendar/festival/{id}",
      "/hi/panchang",
      "/hi/panchang/{city}",
      "/hi/rahu-kaal",
      "/hi/rahu-kaal/{city}",
      "/hi/shubh-muhurat/{city}",
      "/hi/tithi-today",
      "/panchang",
      "/panchang/{city}",
      "/rahu-kaal",
      "/rahu-kaal/{city}",
      "/shubh-muhurat",
      "/shubh-muhurat/{city}",
      "/tithi-today",
    ];
  };
};

const RUNTIME_OFFER_PLACEMENT_VALUE_POOLS = [
  [
    "ChatPaywallTelemetry",
    "GovernedOfferPlacement",
    "OfferImpression",
    "OfferPlacement",
    "ReportReadingUpsellClient",
  ],
  [
    "birth_chart",
    "career",
    "chart_report",
    "chat",
    "dosha_remedy",
    "festival_ritual",
    "forecast",
    "matching",
    "pitra_dosh_report",
    "remedy_dosha",
    "timing_muhurat",
  ],
  [
    "baby_name_report",
    "brihat_kundali",
    "career_report",
    "dosha_remedy_plan",
    "lal_kitab_report",
    "mahadasha_forecast",
    "marriage_report",
    "muhurat_report",
    "numerology_report",
    "pitra_dosh",
    "sade_sati",
  ],
  ["direct_checkout", "input_collection"],
  [
    "/",
    "/ai-astrologer",
    "/ai-kundli",
    "/ascendant-calculator",
    "/astrologer-for-marriage-problem",
    "/baby-names",
    "/bhagyank-calculator",
    "/birth-chart",
    "/blog/karungali-mala-guide",
    "/calendar",
    "/calendar/festival/{id}",
    "/career-astrology",
    "/career-astrology-consultation",
    "/chat-with-astrologer",
    "/chat/{readingId}/",
    "/choghadiya",
    "/choghadiya/{city}",
    "/dasamsa",
    "/dasha-calculator",
    "/free-kundali",
    "/gun-milan",
    "/hi/ascendant-calculator",
    "/hi/baby-names",
    "/hi/bhagyank-calculator",
    "/hi/calendar/festival/{id}",
    "/hi/career-ke-liye-jyotish",
    "/hi/choghadiya",
    "/hi/choghadiya/{city}",
    "/hi/dasamsa",
    "/hi/dasha-calculator",
    "/hi/free-kundali",
    "/hi/gun-milan",
    "/hi/jyotishi-se-baat-karen",
    "/hi/jyotishi-se-chat",
    "/hi/kaal-sarp-dosha",
    "/hi/kundli-matching",
    "/hi/lal-kitab-kundli",
    "/hi/mangal-dosha-calculator",
    "/hi/muft-jyotish-chat",
    "/hi/muhurat",
    "/hi/mulank-calculator",
    "/hi/nadi-astrology",
    "/hi/nakshatra-calculator",
    "/hi/name-numerology",
    "/hi/navamsa-chart",
    "/hi/numerology",
    "/hi/panchang",
    "/hi/panchang/{city}",
    "/hi/pitra-dosha",
    "/hi/rahu-kaal",
    "/hi/rahu-kaal/{city}",
    "/hi/rashi-calculator",
    "/hi/sade-sati",
    "/hi/shaadi-ke-liye-jyotish",
    "/hi/shadbala",
    "/hi/shubh-muhurat/{city}",
    "/hi/tithi-today",
    "/kaal-sarp-dosh",
    "/kaal-sarp-dosha",
    "/kundali/{readingId}",
    "/kundli-matching",
    "/lal-kitab-kundli",
    "/mangal-dosha-calculator",
    "/match/{token}",
    "/muhurat",
    "/muhurat/{event}",
    "/muhurat/{event}/{month}",
    "/mulank-calculator",
    "/nadi-astrology",
    "/nakshatra-calculator",
    "/name-numerology",
    "/navamsa-chart",
    "/numerology",
    "/numerology/{mulank}",
    "/panchang",
    "/panchang/{city}",
    "/pitra-dosh-calculator",
    "/pitra-dosha",
    "/r/{token}",
    "/rahu-kaal",
    "/rahu-kaal/{city}",
    "/rashi-calculator",
    "/sade-sati",
    "/shadbala",
    "/shani-transit",
    "/shubh-muhurat",
    "/shubh-muhurat/{city}",
    "/talk-to-astrologer",
    "/tithi-today",
  ],
] as const;

const RUNTIME_OFFER_PLACEMENT_POLICY_ROWS = [
  ["/choghadiya_report_bridge", [2], [10], [7], [1], [15, 16]],
  ["/dasamsa_report_bridge", [2], [1], [2], [1], [17]],
  ["/dasha-calculator_report_bridge", [2], [2], [5], [1], [18]],
  ["/hi/choghadiya_report_bridge", [2], [10], [7], [1], [26, 27]],
  ["/hi/dasamsa_report_bridge", [2], [1], [2], [1], [28]],
  ["/hi/dasha-calculator_report_bridge", [2], [2], [5], [1], [29]],
  ["/hi/kaal-sarp-dosha_report_bridge", [2], [9], [3], [1], [34]],
  ["/hi/lal_kitab_report_bridge", [2], [2], [4], [1], [36]],
  ["/hi/muhurat_report_bridge", [2], [10], [7], [1], [39]],
  ["/hi/navamsa_chart_report_bridge", [2], [2], [6], [1], [44]],
  ["/hi/pitra-dosha_report_bridge", [2], [9], [9], [1], [48]],
  ["/hi/rashi_calculator_report_bridge", [2], [2], [1], [1], [51]],
  ["/hi/sade-sati_report_bridge", [2], [9], [10], [1], [52]],
  ["/hi/shadbala_report_bridge", [2], [2], [1], [1], [54]],
  ["/kaal-sarp-dosha_report_bridge", [2], [9], [3], [1], [58]],
  ["/lal_kitab_report_bridge", [2], [2], [4], [1], [61]],
  ["/muhurat_report_bridge", [2], [10], [7], [1], [64]],
  ["/navamsa_chart_report_bridge", [2], [2], [6], [1], [71]],
  ["/pitra-dosha_report_bridge", [2], [9], [9], [1], [77]],
  ["/rashi_calculator_report_bridge", [2], [2], [1], [1], [81]],
  ["/sade-sati_report_bridge", [2], [9], [10], [1], [82]],
  ["/shadbala_report_bridge", [2], [2], [1], [1], [83]],
  ["baby_name_lookup_below_result", [2], [2], [0], [1], [5, 22]],
  ["birth_identity_lookup_below_result", [2], [2], [1], [1], [3, 21, 42, 69]],
  ["chat-reading-primary", [3], [3], [], [0], [14]],
  [
    "chat_paywall",
    [0],
    [3],
    [],
    [0],
    [0, 1, 2, 4, 7, 11, 12, 13, 14, 19, 25, 30, 32, 33, 38, 41, 53, 68, 87],
  ],
  ["gun_milan_results_primary", [2], [2], [6], [0], [20]],
  ["hi_gun_milan_results_primary", [2], [2], [6], [0], [31]],
  ["kaal_sarp_result_primary", [1], [4], [3], [0], [57]],
  ["karungali_guide_product_offer", [1], [4], [], [0], [8]],
  [
    "kundali-result-primary",
    [3],
    [0],
    [],
    [0],
    [0, 1, 2, 4, 7, 11, 12, 13, 19, 25, 30, 32, 33, 38, 41, 53, 59, 68, 87],
  ],
  ["kundli_matching_results_primary", [2], [2], [6], [0], [35, 60, 63]],
  ["mangal_dosha_result_primary", [1], [2, 4, 7], [], [0, 1], [37, 62]],
  ["match_share_results_primary", [2], [2], [6], [0], [63]],
  ["muhurat_event_value_moment", [2], [10], [7], [1], [65, 66]],
  ["numerology_lookup_below_result", [2], [2], [8], [1], [6, 23, 40, 43, 45, 67, 70, 72, 73]],
  ["pitra_dosh_result_primary", [1], [8], [9], [0], [76]],
  ["report_reading_upsell", [4], [6], [], [0], [78]],
  ["shani_transit_below_result", [2], [9], [10], [1], [84]],
  [
    "timing_lookup_below_result",
    [2],
    [5, 10],
    [7],
    [1],
    [9, 10, 24, 46, 47, 49, 50, 55, 56, 74, 75, 79, 80, 85, 86, 88],
  ],
] as const;

export type RuntimeOfferPlacementKey = keyof RuntimeOfferPlacementPolicyCatalog;

export type RuntimeOfferPlacementPolicy<
  K extends RuntimeOfferPlacementKey = RuntimeOfferPlacementKey,
> = RuntimeOfferPlacementPolicyCatalog[K];

type PackedRuntimeOfferPlacementPolicy = readonly [
  readonly number[],
  readonly number[],
  readonly number[],
  readonly number[],
  readonly number[],
];

const RUNTIME_OFFER_PLACEMENT_POLICY_INDEX = new Map(
  RUNTIME_OFFER_PLACEMENT_POLICY_ROWS.map(([placement, ...policy]) => [placement, policy] as const)
) as ReadonlyMap<RuntimeOfferPlacementKey, PackedRuntimeOfferPlacementPolicy>;
const RUNTIME_OFFER_PLACEMENT_POLICY_CACHE = new Map<
  RuntimeOfferPlacementKey,
  RuntimeOfferPlacementPolicy
>();

function selectRuntimeValues(pool: readonly string[], indexes: readonly number[]): string[] {
  return indexes.map((index) => {
    const value = pool[index];
    if (value === undefined) throw new Error(`Offer placement policy index ${index} is invalid`);
    return value;
  });
}

function decodeRuntimeOfferPlacementPolicy<K extends RuntimeOfferPlacementKey>(
  packed: PackedRuntimeOfferPlacementPolicy
): RuntimeOfferPlacementPolicy<K> {
  return {
    runtimeOwners: selectRuntimeValues(RUNTIME_OFFER_PLACEMENT_VALUE_POOLS[0], packed[0]),
    intents: selectRuntimeValues(RUNTIME_OFFER_PLACEMENT_VALUE_POOLS[1], packed[1]),
    offerPlans: selectRuntimeValues(RUNTIME_OFFER_PLACEMENT_VALUE_POOLS[2], packed[2]),
    actionModes: selectRuntimeValues(RUNTIME_OFFER_PLACEMENT_VALUE_POOLS[3], packed[3]),
    sourcePathTemplates: selectRuntimeValues(RUNTIME_OFFER_PLACEMENT_VALUE_POOLS[4], packed[4]),
  } as RuntimeOfferPlacementPolicy<K>;
}

export function isRuntimeOfferPlacementKey(
  placement: string
): placement is RuntimeOfferPlacementKey {
  return RUNTIME_OFFER_PLACEMENT_POLICY_INDEX.has(placement as RuntimeOfferPlacementKey);
}

export type RuntimeOfferPlacementIntent<K extends RuntimeOfferPlacementKey> =
  RuntimeOfferPlacementPolicy<K>["intents"][number];

type RuntimeGovernedValue<Values extends readonly string[]> = Values extends readonly []
  ? string
  : Values[number];

export type RuntimeOfferPlacementPlan<K extends RuntimeOfferPlacementKey> = RuntimeGovernedValue<
  RuntimeOfferPlacementPolicy<K>["offerPlans"]
>;

export type RuntimeOfferPlacementActionMode<K extends RuntimeOfferPlacementKey> =
  RuntimeGovernedValue<RuntimeOfferPlacementPolicy<K>["actionModes"]>;

export type RuntimeOfferPlacementOwner<
  K extends RuntimeOfferPlacementKey = RuntimeOfferPlacementKey,
> = RuntimeOfferPlacementPolicy<K>["runtimeOwners"][number];

export type RuntimeOfferPlacementKeyForOwner<Owner extends RuntimeOfferPlacementOwner> = {
  [K in RuntimeOfferPlacementKey]: Owner extends RuntimeOfferPlacementOwner<K> ? K : never;
}[RuntimeOfferPlacementKey];

export type PlacementContract<K extends RuntimeOfferPlacementKey = RuntimeOfferPlacementKey> = {
  placement: K;
  runtimeOwner: RuntimeOfferPlacementOwner<K>;
  intent: RuntimeOfferPlacementIntent<K>;
  planId: RuntimeOfferPlacementPlan<K>;
  actionMode: RuntimeOfferPlacementActionMode<K>;
  sourcePath: string;
  presentationId: string;
};

export function offerPlacementRuntimePolicy<K extends RuntimeOfferPlacementKey>(
  placement: K
): RuntimeOfferPlacementPolicy<K> {
  const cached = RUNTIME_OFFER_PLACEMENT_POLICY_CACHE.get(placement);
  if (cached) return cached as RuntimeOfferPlacementPolicy<K>;
  const packed = RUNTIME_OFFER_PLACEMENT_POLICY_INDEX.get(placement);
  if (!packed) {
    throw new Error(`Offer placement ${placement} is not owned by this runtime`);
  }
  const policy = decodeRuntimeOfferPlacementPolicy<K>(packed);
  RUNTIME_OFFER_PLACEMENT_POLICY_CACHE.set(placement, policy);
  return policy;
}
